import React, { useContext, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import PropTypes from 'prop-types';
import {
  Button,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter, useHistory } from 'react-router-dom';
import { MDBRow, MDBCol } from 'mdbreact';
import functionNames from '../../functionNames.json';
import useTranslateText from '../use_translate_text';
import { commonNodeModules, commonModules } from '../index';
import './function_page_header.scss';

const FunctionsPageHeader = (props) => {
  const { Box } = commonNodeModules,
        { UserContext, setValue, getValue, useRoutePath, storeContext } = commonModules;

  const { translateText } = useTranslateText(),
        { getBasePath } = useRoutePath(),
        context = useContext(UserContext),
        { state: storeState } = useContext(storeContext),
        history = useHistory(),
        pageStyle = `
          @page {
            size: 80mm 50mm;
          }

          @media all {
            .pagebreak {
              display: none;
            }
          }

          @media print {
            .pagebreak {
              page-break-before: always;
            }
          }
        `,
        { state } = context || {},
        { LangCode } = storeState || getValue('LangCode') || {},
        { NavFunctions } = state || {},
        routedPage = () => {
          // props.history.goBack();
          const basePath = props.listPagePath || getBasePath('dashboard');
          history.push(basePath);
          window.scrollTo(0, 0);
          const { setInputValue = { setInputValue: false } } = context || {};
          if (typeof setInputValue === 'function')
            setInputValue('');
        },
        { children, hideArrowBtn, printPopUp } = props,
        componentRef = useRef(null),
        handlePrint = useReactToPrint({
          content: () => componentRef.current,
          pageStyle: pageStyle,
        }),
        setMenuSelect = (navFunctionDataArray, functionName) => {
          const functionNamesJson = functionNames,
                { inputValue, setInputValue } = context || {},
                functionDescName = inputValue ? functionName :
                  functionName !== 'Address Information' && functionName !== 'E-Mail Address'
                    ? functionName?.replace(/Update|Add|Add\/Edit|Details|Detail/g, '') : functionName;
          let record = null;
          //setValue('program', functionName);
          if (LangCode === 'ES') {
            for (let item in functionNamesJson) {
              if (item === functionName) {
                record = navFunctionDataArray.find((el) => el.navFunctionDesc.trim() === functionNamesJson[item].trim());
              }
            }
          }
          else {
            record = navFunctionDataArray.find((el) => el.navFunctionDesc.trim() === functionDescName.trim());
          }
          if (record && context.isOnboarding !== 'true') {
            if (record.navMenu === 'Personal') {
              context.setMenu('Personal');
              setValue('Menu', 'Personal');
            }
            else if (record.navMenu === 'Payroll') {
              context.setMenu('Payroll');
              setValue('Menu', 'Payroll');
            }
            else if (record.navMenu === 'Benefits') {
              context.setMenu('Benefits');
              setValue('Menu', 'Benefits');
            }
          }
          const checkValue = LangCode === 'ES' ? functionNames[inputValue] : inputValue;
          if (record?.navFunctionDesc !== checkValue && typeof setInputValue === 'function') {
            setInputValue('');
          }
          return;
        };

  useEffect(() => {
    if (NavFunctions) {
      const { state: { NavFunctions: { navFunctionData } } } = context || {};
      let menuFunction = props.functionName;
      if (props.functionName.includes('Life Event')) {
        menuFunction = 'Life Events';
      }
      setMenuSelect(navFunctionData, menuFunction);
      if (context.isOnboarding === 'true') {
        context.setIsOnboardPage(true);
        setValue('setIsOnboardPage', true);
      }
    }
  }, []);

  return (
    <Box className="function-page-header" ref={componentRef}>
      <MDBRow className="function-page-header__row-container">
        <MDBCol size="9">
          <Box className="d-flex">
            {context.isOnboarding === 'true' ? null : !hideArrowBtn &&
            <FontAwesomeIcon
              title={`${translateText('Back')}`}
              className="function-page-header__back-icon"
              onClick={props.onchange ? props.onchange : routedPage}
              icon="arrow-left"
              size="2x"
              style={{ cursor: 'pointer' }}
            />}
            { <h6 className="function-page-header__heading">
              {context.isOnboarding === 'true' && props.functionName.trim() !== 'Cambie Idioma' && props.functionName.trim() !== 'Change Language'
                && `${translateText(state.Program + ' Step')} ${context.selectedTask || 1}: `}{props.functionName}
            </h6>}
          </Box>
        </MDBCol>
        <MDBCol size="3" className="function-page-header__align-right">
          {props.printBtn &&
            <Button
              onClick={props.isDiv ? () => {
                // try {
                //   document.execCommand('print', false, null); //no alternate for this command
                // }
                // catch (e) {
                window.print();
                // }
              } : (printPopUp || handlePrint)}
              className="w-unset btn function-page-header__print"
              icon="print"
              title={`${translateText('Print')}`}
              fontSize="13px"
            >
              <FontAwesomeIcon
                icon="print" className="mr-1"
              />
              {`${translateText('Print')}`}
            </Button>
          }
        </MDBCol>
      </MDBRow>
      {children}
    </Box>
  );
};

export default withRouter(FunctionsPageHeader);

FunctionsPageHeader.propTypes = {
  onchange: PropTypes.func,
  functionName: PropTypes.string,
  printBtn: PropTypes.bool,
  arrowBtn: PropTypes.bool,
  component: PropTypes.func,
};